import { DividerPosition, DividerVariant } from './Divider';
import { ResponsiveParameter, generateResponsiveMapping } from 'omakase/utils/responsiveSizeMap';
import { Theme, css } from '@emotion/react';

const THICK_VARIANT_HEIGHT = '12px';
const THIN_VARIANT_HEIGHT = '1px';

const calculateMargins = (
  { spacing }: Theme,
  isTall: boolean,
  dividerPosition: DividerPosition | undefined
) => {
  if (!dividerPosition) {
    return {
      marginTop: 0,
      marginTopDesktop: 0,
      marginBottom: 0,
      marginBottomDesktop: 0,
    };
  }
  const actualYMargin = `${spacing(isTall ? 4 : 3)}px`;
  const actualDesktopYMargin = `${spacing(isTall ? 5.5 : 3.5)}px`;
  return {
    marginTop: dividerPosition === 'top' ? '0' : actualYMargin,
    marginTopDesktop: dividerPosition === 'top' ? '0' : actualDesktopYMargin,
    marginBottom: dividerPosition === 'bottom' ? '0' : actualYMargin,
    marginBottomDesktop: dividerPosition === 'bottom' ? '0' : actualDesktopYMargin,
  };
};

/**
 * The root component class
 */

export const dividerBase =
  ({
    isTall,
    position,
    variant,
    mt,
    mb,
  }: {
    isTall: boolean;
    position: DividerPosition | undefined;
    variant: DividerVariant;
    mt?: ResponsiveParameter<number>;
    mb?: ResponsiveParameter<number>;
  }) =>
  (theme: Theme) => {
    const { marginTop, marginTopDesktop, marginBottom, marginBottomDesktop } = calculateMargins(
      theme,
      isTall,
      position
    );

    const marginBottomStyles = mb
      ? generateResponsiveMapping<number>(
          theme,
          mb,
          (valueForBreakpoint) => css`
            margin-bottom: ${theme.spacing(valueForBreakpoint)}px;
          `
        )
      : [];

    const marginTopStyles = mt
      ? generateResponsiveMapping<number>(
          theme,
          mt,
          (valueForBreakpoint) => css`
            margin-top: ${theme.spacing(valueForBreakpoint)}px;
          `
        )
      : [];

    return [
      css`
        background-color: ${variant === 'thin' ? theme.colors.borderDefault : theme.colors.bgLight};
        list-style: none;
        margin-bottom: ${marginBottom};
        margin-top: ${marginTop};
        width: 100%;
        height: ${variant === 'thin' ? THIN_VARIANT_HEIGHT : THICK_VARIANT_HEIGHT};
      `,
      variant === 'responsive' &&
        css`
          ${theme.breakpoints.up('sm')} {
            background-color: ${theme.colors.borderDefault};
            height: ${THIN_VARIANT_HEIGHT};
          }
        `,
      position &&
        css`
          ${theme.breakpoints.up('sm')} {
            margin-bottom: ${marginBottomDesktop};
            margin-top: ${marginTopDesktop};
          }
        `,
      [...marginBottomStyles],
      [...marginTopStyles],
    ];
  };
